import { composeIO } from 'react-compose-io'
import { graficoValorQuantidadeClassificacoesIO } from './GraficoValorQuantidadeClassificacoes.IO'
import { GraficoValorQuantidadeClassificacoesView } from './GraficoValorQuantidadeClassificacoes.View'

export const GraficoValorQuantidadeClassificacoes = composeIO(GraficoValorQuantidadeClassificacoesView, graficoValorQuantidadeClassificacoesIO)
